/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./industry-category-cascader.vue?vue&type=template&id=1a513ea0&scoped=true&"
import script from "./industry-category-cascader.vue?vue&type=script&lang=js&"
export * from "./industry-category-cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a513ea0",
  null
  
)

export default component.exports